import React from 'react'
import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import * as loaderAnimA from './luna-basic-loader.json'
import * as loaderAnimB from './luna-loader.json'
import _ from 'lodash'

export class LunaLoader extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            style: this.props.style ? this.props.style : 'default'
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.style !== prevProps.style) {
            document.body.scrollTop = document.documentElement.scrollTop = 0
        }
        let self = this
        if (this.props.triggerFade) {
            _.delay(function() {
                $('.luna-loader').fadeOut('5000', (e) => {
                    self.props.onFadeLoader()
                })
            },
            2500
            )
        }
    }

    componentWillUnmount = () => {
        if (this.refs && this.refs.animation) {
            this.refs.animation.destroy()
        }
    }

    render() {
        if (this.props.triggerFade && !this.props.triggerFade) {
            return null
        }

        let defaultOptions = {
            loop: true,
            autoplay: true,
            prerender: true,
            animationData: this.props.style && this.props.style === 'basic' ? loaderAnimA.default : loaderAnimB.default,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        }

        return (
            <div className="luna-loader">
                <Lottie
                    options={defaultOptions}
                    ref={(animation) => {
                      this.animation = animation
                    }}/>
            </div>
        )
    }
}

LunaLoader.propTypes = {
    triggerFade: PropTypes.bool,
    style: PropTypes.string
}